import {FC, useCallback} from 'react';
import {observer} from 'mobx-react-lite';
import {Box, Center, Text} from '@chakra-ui/react';
import {getDateTimeString, useT} from '@progress-fe/core';
import {ShowMore} from '@progress-fe/ui-kit';
import {v4 as uuidv4} from 'uuid';
import {IJournalPointItem} from 'core/interfaces';
import {EJournalItemType} from 'core/enums';

interface IProps {
  items: IJournalPointItem[];
}

const JournalPointItemsFC: FC<IProps> = ({items}) => {
  const {t} = useT();

  const getColor = useCallback((type: EJournalItemType) => {
    switch (type) {
      case EJournalItemType.Error:
        return 'darkRed';
      case EJournalItemType.Warning:
        return 'darkOrange';
      case EJournalItemType.Success:
        return 'success';
      default:
        return 'black';
    }
  }, []);

  if (!items.length) {
    return (
      <Center fontFamily="ptmono" h={'100%'}>
        {t('common.journalEmpty')}
      </Center>
    );
  }

  return (
    <Box p={'6px 6px 2px 6px'} fontFamily="ptmono">
      {items?.map((item) => (
        <Box
          key={uuidv4()}
          pb={'2px'}
          fontSize={'12px'}
          lineHeight={'16px'}
          color={getColor(item.type)}
          whiteSpace={'pre-line'}
        >
          <ShowMore>
            <b>
              <Text as="span" fontSize={'12px'} fontWeight={600} color={'inherit'}>
                {getDateTimeString(item.createdAt)}:{' '}
              </Text>
            </b>
            {item.message}
          </ShowMore>
        </Box>
      ))}
    </Box>
  );
};

export const JournalPointItems = observer(JournalPointItemsFC);
